import {
  ICheckboxProps,
  IDropdownProps,
  IRadioProps,
  ITextInputProps
} from './types';

export const getDescribedBy = ({
  hasHelpText,
  hasErrors,
  id
}: {
  hasHelpText: boolean;
  hasErrors: boolean;
  id: string;
}) => {
  return [
    `${hasHelpText ? `${id}HelpText` : ''}`,
    `${hasErrors ? `${id}Error` : ''}`
  ]
    .filter(s => !!s)
    .join(' ');
};
